module.exports = __webpack_public_path__ + "static/media/pos icon 2.816f8de1.png";